<template>
  <div class="add-switch-box">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="handleClose"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
    >
      <el-form ref="form" :model="params" :rules="rules" label-width="100px">
        <el-form-item label=" 名称:" prop="name">
          <el-input v-model="params.buttons.name" size="small" placeholder="请输入名称"></el-input>
        </el-form-item>
        <el-form-item label=" 类型:" prop="type">
          <el-select v-model="params.buttons.type" size="small" placeholder="请选择类型" clearable>
            <el-option
              v-for="item in typeList"
              :value="item.value"
              :label="item.label"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label=" 样式:" prop="style">
          <el-select v-model="params.buttons.style" size="small" placeholder="请选择样式" clearable>
            <el-option
              v-for="item in styleList"
              :value="item.value"
              :label="item.label"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label=" 显示按钮:" prop="enable">
          <el-switch v-model="params.buttons.enable"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" :loading="flag" size="small">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from "@/api";
export default {
  data() {
    return {
      dialogVisible: false,
      title: "",
      flag: false,
      // 新增页面所需要数组
      arr: [],
      // 当前行索引
      index: "",
      operType: "add",
      params: {
        id: "",
        templet: "",
        buttons: {
          name: "",
          enable: false,
          type: "",
          style: "switchStress"
        }
      },
      typeList: [
        { label: "ios企业包开关", value: "iosEnterprise" },
        { label: "ios商店包开关", value: "iosStore" },
        { label: "安卓开关", value: "android" }
      ],
      styleList: [
        { label: "突出", value: "switchStress" },
        { label: "简单", value: "switchSimple" }
      ],
      rules: {}
    };
  },
  methods: {
    // 表单验证提交
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.operType === "edit") {
            this.flag = true;
            this.edit();
          } else {
            this.flag = true;
            this.add();
          }
        } else {
          return false;
        }
      });
    },
    edit() {
      let param = JSON.parse(JSON.stringify(this.params));
      this.arr[this.index] = param.buttons;
      param.buttons = this.arr;
      API.updateLdy(param).then(res => {
        if (res.code === 200) {
          this.$message({
            message: "编辑成功",
            type: "success"
          });
          this.$emit("handlerSwitch");
        } else {
          this.$message.error("编辑失败,请重试");
        }
        this.handleClose();
        this.flag = false;
      });
    },
    add() {
      this.params.buttons = [this.params.buttons].concat(this.arr);
      // this.params.buttons.enable = ![this.params.buttons].concat(this.arr);
      API.updateLdy(this.params).then(res => {
        if (res.code === 200) {
          this.$message({
            message: "添加成功",
            type: "success"
          });
          this.$emit("handlerSwitch");
        } else {
          this.$message.error("添加失败,请重试");
        }
        this.handleClose();
        this.flag = false;
      });
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.params.id = "";
      this.params.templet = "";
      this.params.buttons = {
        name: "",
        enable: false,
        type: "",
        style: ""
      };
      this.$refs.form.resetFields();
    },
    open(type, param) {
      // eslint-disable-next-line no-console
      console.log(param, "===");
      this.dialogVisible = true;
      this.operType = type;
      if (type === "edit") {
        this.title = "编辑按钮配置";
        this.arr = param.arr;
        let row = param.arr[param.index];
        this.index = param.index;
        this.params.buttons = {
          name: row.name,
          enable: row.enable,
          type: row.type,
          style: row.style
        };
        this.params.id = param.id;
        this.params.templet = param.templet;
      } else {
        this.title = "新增按钮配置";
        this.params.id = param.id;
        this.params.templet = param.templet;
        this.arr = param.arr;
      }
    }
  }
};
</script>

<style lang="scss" >
.add-switch-box {
  .el-input {
    width: 150px;
  }
  .avatar-uploader {
    width: 150px;
    height: 150px;
  }
  .el-upload {
    width: 100%;
    height: 100%;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    &:hover {
      border: 1px dashed #e63765;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
    &:hover {
      color: 1px dashed #e63765 !important;
    }
  }
}
</style>
